@if (!showErrorScreen) {
  <div #meetingContainer id="rtk-meeting-container">
    <rtk-meeting #meet></rtk-meeting>
  </div>
} @else {
  <div class="meeting-overlay-container">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="48px"
      viewBox="0 -960 960 960"
      width="48px"
      fill="#e8eaed"
    >
      <path
        d="M220-80q-24.75 0-42.37-17.63Q160-115.25 160-140v-434q0-24.75 17.63-42.38Q195.25-634 220-634h70v-96q0-78.85 55.61-134.42Q401.21-920 480.11-920q78.89 0 134.39 55.58Q670-808.85 670-730v96h70q24.75 0 42.38 17.62Q800-598.75 800-574v434q0 24.75-17.62 42.37Q764.75-80 740-80H220Zm0-60h520v-434H220v434Zm260.17-140q31.83 0 54.33-22.03T557-355q0-30-22.67-54.5t-54.5-24.5q-31.83 0-54.33 24.5t-22.5 55q0 30.5 22.67 52.5t54.5 22ZM350-634h260v-96q0-54.17-37.88-92.08-37.88-37.92-92-37.92T388-822.08q-38 37.91-38 92.08v96ZM220-140v-434 434Z"
      />
    </svg>

    <h3>Sorry, You don't have access to this meeting</h3>

    <h6>Please contact support if issue persists</h6>
  </div>
}

<div data-theme="dark">
  <dialog id="my_modal_2" class="daisy-modal" open="true">
    <div class="daisy-modal-box">
      <h3 class="text-lg font-bold">Hello!</h3>
      <p class="py-4">
        Your Meeting is about to start. Do you want to enter full screen mode?
      </p>
      <div class="daisy-modal-action">
        <form method="dialog">
          <button class="daisy-btn">No</button>
          <button
            class="daisy-btn daisy-btn-primary ml-2"
            (click)="enterFullScreen()"
          >
            Yes
          </button>
        </form>
      </div>
    </div>
    <form method="dialog" class="daisy-modal-backdrop">
      <button>close</button>
    </form>
  </dialog>
</div>
